import {
    ComponentConfig,
    LayoutTypes,
    ComponentType,
    FlexDirection,
} from "../services/types/ComponentTypes";

export const screen_2221_holiday_list: ComponentConfig[] = [
    {
        componentType: LayoutTypes.SCREEN_GROUP,
        title: "Holidays",
        style: {
            backgroundColor: "#F9FAFB",
        },
        childComponents: [
            {
                componentType: LayoutTypes.GROUP,
                style: {
                    backgroundColor: "#ffffff",
                    direction: FlexDirection.COLUMN,
                    borderRadius: 12,
                    padding: 16,
                },
                childComponents: [
                    {
                        componentType: ComponentType.SUMMARY_LIST,
                        DisplayName: "All Holidays",
                        Name: "holiday_list",
                        apiname: "holiday_list",
                        titleValue: "holiday_name",
                        TableName: "holiday_list",
                        Filter: "holiday_list.soft_delete=0",
                        Form: {
                            Name: "holiday_list",
                            TableName: "holiday_list",
                            HasLockedColumn: false,
                            Fields: [
                                {
                                    IncludeLabel: true,
                                    Label: "Holiday Name",
                                    BindValue: "holiday_name",
                                    Json_Attribute: "holiday_name",
                                    componentType: ComponentType.TEXT_FIELD,
                                    showInSummary: true,
                                },
                                {
                                    IncludeLabel: true,
                                    Label: "Holiday Date",
                                    BindValue: "holiday_date",
                                    Json_Attribute: "holiday_date",
                                    componentType: ComponentType.DATE_FIELD,
                                    showInSummary: true,
                                },
                                {
                                    IncludeLabel: true,
                                    Label: "Holiday Type",
                                    BindValue: "holiday_type",
                                    Json_Attribute: "holiday_type",
                                    componentType: ComponentType.TEXT_FIELD,
                                    showInSummary: true,
                                },
                                {
                                    IncludeLabel: true,
                                    Label: "Applicable To",
                                    BindValue: "applicable_to",
                                    Json_Attribute: "applicable_to",
                                    componentType: ComponentType.TEXT_FIELD,
                                    showInSummary: true,
                                },
                                {
                                    IncludeLabel: true,
                                    Label: "Paid Holiday",
                                    BindValue: "paid_holiday",
                                    Json_Attribute: "paid_holiday",
                                    componentType: ComponentType.TEXT_FIELD,
                                    showInSummary: true,
                                    valueFormat: "boolean",
                                } as any,
                            ],
                        },
                        SummeryActions: [
                            {
                                ActionType: "Edit",
                                Label: "Edit",
                                Action: {
                                    Action: "edit_holiday",
                                },
                                ScreenId: "2224",
                                visibility: [1],
                            },
                            {
                                ActionType: "Delete",
                                Label: "Delete",
                                Action: {
                                    Action: "Delete",
                                    Module: "holiday_list",
                                },
                                visibility: [1],
                            },
                        ],
                    } as any,
                ],
            },
        ],
    },
];
